import React, { useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import Title from 'components/Title'
import CorporateAccountList from 'components/Table/BasicTable'
import ActionDropdown from 'components/Table/ActionDropdown'
import DeleteConfirm from 'components/Modal/DeleteConfirm'
import { Input, message,Button } from 'antd';
import InviteModal from './components/InviteModal'
import { DataGetAction, DataRequestAction } from 'redux/actions/http';
import { useDispatch, useSelector } from 'react-redux'
import SelectFilter from 'components/Filters/CallFilters'
// import { renderStatus } from 'utils/commonUseFunction'
import IntlMessages from 'util/IntlMessages'
import ResetPasswordModal from './components/ResetPasswordModal'
import { Link } from "react-router-dom";
import { ReloadOutlined } from '@ant-design/icons';
const Index = () => {

    const dispatch = useDispatch()

    
    const fetchTableData = () => {
        dispatch(DataGetAction('getCorporateAccounts', { query: "all" }, 'gettingCorporateAccounts'));
    }
    useEffect(fetchTableData, [])


    const usersProps = useSelector(state => state.users)
    const { usersList, textMessage, success, error, corporateAccountSpinner } = usersProps


    console.log('========userLists=======', usersList)

    const renderStatus = (status) => {
        if (status === 'active') {
            return <span style={{ color: '#3FD4A2' }}>Active</span>
        }
        if (status === 'block') {
            return <span style={{ color: 'red' }}>Blocked</span>
        }
        if (status === 'invited') {
            return <span style={{ color: '#F7A626' }}>Invited</span>
        }
        else {
            return <span style={{ color: 'black' }}>{status}</span>
        }
    }

    const columns = [
        {
            title: <IntlMessages id="corporateAccount.id" />,
            render: record => <span>{record.userId}</span>,
            key: "userId"
        },
        {
            title: <IntlMessages id="corporateAccount.fullName" />,
            render: record => <span>{record.fullName}</span>,
            key: "firstName"
        },
        {
            title: <IntlMessages id="corporateAccount.companyName" />,
            render: record => <span>{record.companyName}</span>,
            key: "firstName"
        },
        {
            title: <IntlMessages id="corporateAccount.email" />,
            render: record => <span>{record.email}</span>,
            key: "email"
        },
        {
            title: <IntlMessages id="corporateAccount.phone" />,
            render: record => <span>{record.phoneNumber}</span>,
            key: "phone"
        },
        {
            title: <IntlMessages id="corporateAccount.membership" />,
            render: record => <span style={{ color: '#A6EBD4' }}>${record.corporateAccountCharges || 0}</span>,
            key: "membership"
        },
        {
            title: <IntlMessages id="corporateAccount.accountManager" />,
            render: record => <Link to={{
                pathname: "/accountManager",
                state: { _id: record._id }
            }}>
                <span >{record.totalAccountManagerAccounts || 0}</span>
            </Link>,
            key: "membership"
        },
        {
            title: <IntlMessages id="corporateAccount.careRecipientAccount" />,
            render: record => <Link to={{
                pathname: "/careRecipientAccounts",
                state: { _id: record._id }
            }}>
                <span >{record.totalCareRecipients || 0}</span>
            </Link>,
            key: "membership"
        },
        {
            title: <IntlMessages id="corporateAccount.status" />,
            render: record => <span> {renderStatus(record.status)}</span>,
            key: "phone"
        },
        {
            title: '',
            render: (record) => <ActionDropdown menu={renderActions(record)}></ActionDropdown>,
            key: "action"
        },
    ]



    const editRecord = (record, action) => {

        if (action === 'changePricing') {
            record.action = 'changePricing'
        }
        if (action === 'edit') {
            record.action = 'edit'
        }

        dispatch({
            type: "Invite_Modal",
            payload: record
        })
    }
    const resetModal = (record) => {

        dispatch({
            type: "ResetPassword_Modal",
            payload: record
        })
    }


    const updateStatus = (record, status) => {
        dispatch(DataRequestAction('PUT', 'updateUserStatus', { userId: record._id, status: status }, '', 'blockingUser', false));
    }


    // const data = [{
    //     userId: 1,
    //     _id: 1,
    //     fullName: 'umar',
    //     companyName: 'company A',
    //     email: 'a@g.com',
    //     phoneNumber: '121243',
    //     membership: '300',
    //     accountManager: '10',
    //     careRecipientAccount: '20',
    //     status: 'block',
    //     mainMembershipCharges: 200,
    //     perSeatCharges: 500,
    // }]




    const renderActions = (record) => {
        return <div className="gx-d-flex gx-flex-column">
            {record.status === 'invited' && <DeleteConfirm
                type="reInviteUser"
                method="POST"
                okText={'Yes'}
                selectedItem={record}
                buttonName="Yes"
                title="Are you sure you want to reinvite this user?"
                content=""
                Icon={<span style={{ fontSize: '14px' }}>Reinvite</span>}
            />}
            {record.status === 'block' && <span style={{ cursor: 'pointer' }} onClick={() => {

                updateStatus(record, 'active')
            }}> Active </span>}
            {record.status === 'active' && <span style={{ cursor: 'pointer' }} onClick={() => {


                updateStatus(record, 'block')
            }}> Block </span>}

            <span style={{ cursor: 'pointer' }} onClick={() => editRecord(record, 'edit')}> Edit </span>
            <span style={{ cursor: 'pointer' }} onClick={() => editRecord(record, 'changePricing')}> Change Pricing </span>
            {record.status !== 'invited' && <span style={{ cursor: 'pointer' }} onClick={() => resetModal(record)}> Reset Password </span>}


        </div>
    }


    if (success) {
        message.success(textMessage)
        dispatch({
            type: "reset_corporateAccount_States"
        })
    }
    if (error) {
        message.error(textMessage)
        dispatch({
            type: "reset_corporateAccount_States"
        })
    }



    return (
        <Layout>
            <div className="gx-d-block gx-flex-row gx-justify-content-between">
                <div className="gx-d-flex gx-flex-row">
                    <div className="gx-mb-2 gx-mb-md-0">
                        <Title title="Corporate Accounts" />
                    </div>
                    


                </div>

                <div className="gx-d-flex">
                    <div className="gx-mr-3 gx-mb-3 gx-mb-md-0">
                        <SelectFilter placeholder="Filter by status" isShowingAll={true} apiName="getCorporateAccounts" searchKey="status" options={[
                            { status: "invited", "label": "Invited" },
                            { status: "block", "label": "Blocked" },
                            { status: "active", "label": "Active" },
                        ]} ItemValue="status" label="label" />
                    </div>
                    <div className="gx-my-0 gx-mr-md-3 gx-mx-0" style={{ width: '200px' }}>
                        <Input.Search
                            showSearch
                            placeholder="Full Name/Email"
                            filterOption={false}
                            onChange={(e) => dispatch(DataGetAction('getCorporateAccounts', { name: e.target.value }, ''))}

                        />
                    </div>


                    <InviteModal />
                    <div>
                        <Button type="primary" className="gx-pt-0 gx-ml-3" onClick={() => { fetchTableData() }} icon={<ReloadOutlined spin={corporateAccountSpinner ? true : false} />} />
                    </div>
                </div>



            </div>
            <CorporateAccountList loading={corporateAccountSpinner} data={corporateAccountSpinner ? [] : usersList} columns={columns} />
            <ResetPasswordModal />
        </Layout >
    )
}

export default Index
